import { render, staticRenderFns } from "./BlockType104.vue?vue&type=template&id=cd50906e&scoped=true"
import script from "./BlockType104.vue?vue&type=script&lang=ts"
export * from "./BlockType104.vue?vue&type=script&lang=ts"
import style0 from "./BlockType104.vue?vue&type=style&index=0&id=cd50906e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd50906e",
  null
  
)

export default component.exports